module.exports = __webpack_public_path__ + "img/cpp.0d80d862.png";